import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClientLookupDataModel, ClientLookupParamsModel } from '../interfaces/client-lookup';

@Injectable({
  providedIn: 'root'
})
export class ClientLookupService {
    private serverUrl = 'https://' + window.location.host;
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/ClientLookup/').replace(
        '{version}',
        this.version
    );

    constructor(private _http: HttpClient) { }

    getClientLookupMappings(parameters: ClientLookupParamsModel) {
        return this._http.post<ClientLookupDataModel[]>(
            this._url + 'GetClientLookupMappings',
            parameters,
            {
                headers: new HttpHeaders({ 'Content-Type': 'application/json' })
            }
        );
    }

    getLookupValues(parameters: ClientLookupParamsModel) {
        return this._http.post<ClientLookupDataModel[]>(
            this._url + 'GetLookupValues',
            parameters,
            {
                headers: new HttpHeaders({ 'Content-Type': 'application/json' })
            }
        );
    }

    getLookupDataTypes() {
        return this._http.post<ClientLookupDataModel[]>(
            this._url + 'GetLookupDataTypes',
            {
                headers: new HttpHeaders({ 'Content-Type': 'application/json' })
            }
        );
    }

    submitChanges(clientLookupParamsArray: ClientLookupParamsModel[]) {
        return this._http.post<any>(
            this._url + 'SubmitChanges',
            clientLookupParamsArray,
            {
                headers: new HttpHeaders({ 'Content-Type': 'application/json' })
            }
        );
    }
}
